/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import SelectBoxGroup from './group/index';
import SelectBoxInput from './input/index';
import SelectBoxOption from './option/index';
import SelectBoxOptions from './options/index';
import SelectBoxSelectedOption from './selected-option/index';
import SelectBoxSelectedOptions from './selected-options/index';
import { _selectOption, selectOption } from '../../utils/select-box/option/select';
import { deactivateOptions, activateNextOption, activateOption, activateOptionAtIndex, activateOptionForKeyCode, activateOptionForValue, activatePreviousOption } from '../../utils/select-box/option/activate';
import { blurInput, focusInput } from '../../utils/select-box/input/focus';
import { cancelSearch, maybeSearch, search } from '../../utils/select-box/search';
import { close, open, toggle } from '../../utils/select-box/toggle';
import { deregisterElement, registerElement } from '../../utils/registration/element';
import { deregisterInput, registerInput } from '../../utils/registration/input';
import { deregisterSelectedOption, registerSelectedOption } from '../../utils/registration/selected-option';
import { deregisterSelectedOptions, registerSelectedOptions } from '../../utils/registration/selected-options';
import { deregisterOption, registerOption } from '../../utils/registration/option';
import { deregisterOptions, registerOptions } from '../../utils/registration/options';
import { focusOut } from '../../utils/select-box/focus';
import { keyDown, keyPress } from '../../utils/select-box/keyboard';
import { setInputValue } from '../../utils/select-box/input/value';
import buildAPI from '../../utils/shared/api';
import { receiveValue, selectValue, updateValue } from '../../utils/shared/value';
import { ready } from '../../utils/shared/ready';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
let SelectBox = (_class = class SelectBox extends Component {
  get api() {
    return buildAPI(this, [
    // Components
    'Group', 'Input', 'Option', 'Options', 'SelectedOption', 'SelectedOptions',
    // Properties
    'element', 'isBusy', 'isDisabled', 'isFulfilled', 'isMultiple', 'isOpen', 'isPending', 'isRejected', 'isSearching', 'isSettled', 'isSlowSearch', 'value',
    // Actions
    'activateNextOption', 'activateOptionAtIndex', 'activateOptionForKeyCode', 'activateOptionForValue', 'activatePreviousOption', 'blurInput', 'cancelSearch', 'close', 'deactivateOptions', 'focusInput', 'open', 'search', 'select', 'selectActiveOption', 'setInputValue', 'toggle', 'update']);
  }
  get activeOption() {
    return this.option[this.activeOptionIndex];
  }
  get role() {
    return this.input ? 'combobox' : 'listbox';
  }
  get isListbox() {
    return this.role === 'listbox';
  }
  get isCombobox() {
    return this.role === 'combobox';
  }
  get tabIndex() {
    return this.isDisabled || this.isCombobox ? '-1' : '0';
  }
  get isBusy() {
    return this.isPending || this.isSearching;
  }
  get isDisabled() {
    return !!this.args.disabled;
  }
  get isMultiple() {
    return !!this.args.multiple;
  }
  get isMultiSelectable() {
    return this.isMultiple && this.isListbox;
  }
  get labelledBy() {
    if (this.selectedOptions) {
      return this.selectedOptions.id;
    } else if (this.selectedOption.length > 0) {
      return this.selectedOption[0].id;
    } else if (this.input) {
      return this.input.id;
    } else {
      return null;
    }
  }
  get searchDelayTime() {
    return this.args.searchDelayTime ?? 100;
  }
  get searchMinChars() {
    return this.args.searchMinChars ?? 1;
  }
  get searchSlowTime() {
    return this.args.searchSlowTime ?? 500;
  }
  constructor() {
    super(...arguments);
    // Misc state
    _defineProperty(this, "element", null);
    _defineProperty(this, "optionCharState", null);
    _defineProperty(this, "previousValue", null);
    _defineProperty(this, "sealedAPI", {});
    _defineProperty(this, "searchId", 0);
    _defineProperty(this, "valueId", 0);
    // Tracked state
    _initializerDefineProperty(this, "activeOptionIndex", _descriptor, this);
    _initializerDefineProperty(this, "isFulfilled", _descriptor2, this);
    _initializerDefineProperty(this, "isOpen", _descriptor3, this);
    _initializerDefineProperty(this, "isPending", _descriptor4, this);
    _initializerDefineProperty(this, "isReady", _descriptor5, this);
    _initializerDefineProperty(this, "isRejected", _descriptor6, this);
    _initializerDefineProperty(this, "isSearching", _descriptor7, this);
    _initializerDefineProperty(this, "isSettled", _descriptor8, this);
    _initializerDefineProperty(this, "isSlowSearch", _descriptor9, this);
    _initializerDefineProperty(this, "value", _descriptor0, this);
    // Component classes
    _defineProperty(this, "SelectBoxGroup", SelectBoxGroup);
    _defineProperty(this, "SelectBoxInput", SelectBoxInput);
    _defineProperty(this, "SelectBoxOption", SelectBoxOption);
    _defineProperty(this, "SelectBoxOptions", SelectBoxOptions);
    _defineProperty(this, "SelectBoxSelectedOption", SelectBoxSelectedOption);
    _defineProperty(this, "SelectBoxSelectedOptions", SelectBoxSelectedOptions);
    // Component declarations
    _defineProperty(this, "Group", null);
    _defineProperty(this, "Input", null);
    _defineProperty(this, "Option", null);
    _defineProperty(this, "Options", null);
    _defineProperty(this, "SelectedOption", null);
    _defineProperty(this, "SelectedOptions", null);
    // Component instances
    _initializerDefineProperty(this, "input", _descriptor1, this);
    _initializerDefineProperty(this, "option", _descriptor10, this);
    _initializerDefineProperty(this, "options", _descriptor11, this);
    _initializerDefineProperty(this, "selectedOption", _descriptor12, this);
    _initializerDefineProperty(this, "selectedOptions", _descriptor13, this);
    _defineProperty(this, "pendingOption", []);
    receiveValue(this);
  }
  handleInsertElement(element) {
    registerElement(this, element);
    ready(this);
  }
  handleDestroyElement() {
    deregisterElement(this);
  }
  handleUpdateValue() {
    receiveValue(this);
  }
  handleInsertOption(option) {
    registerOption(this, option);
  }
  handleDestroyOption(option) {
    deregisterOption(this, option);
  }
  handleInsertOptions(options) {
    registerOptions(this, options);
  }
  handleDestroyOptions(options) {
    deregisterOptions(this, options);
  }
  handleInsertSelectedOption(selectedOption) {
    registerSelectedOption(this, selectedOption);
  }
  handleDestroySelectedOption(selectedOption) {
    deregisterSelectedOption(this, selectedOption);
  }
  handleInsertSelectedOptions(selectedOptions) {
    registerSelectedOptions(this, selectedOptions);
  }
  handleDestroySelectedOptions(selectedOptions) {
    deregisterSelectedOptions(this, selectedOptions);
  }
  handleInsertInput(input) {
    registerInput(this, input);
  }
  handleDestroyInput(input) {
    deregisterInput(this, input);
  }
  handleInputText(text) {
    maybeSearch(this, text);
  }
  handleFocusOut(e) {
    focusOut(this, e);
  }
  handleKeyPress(e) {
    keyPress(this, e);
  }
  handleKeyDown(e) {
    keyDown(this, e);
  }
  handleSelectOption(option) {
    selectOption(this, option);
  }
  handleActivateOption(option) {
    activateOption(this, option);
  }
  select(value) {
    return selectValue(this, value);
  }
  update(value) {
    return updateValue(this, value);
  }
  selectActiveOption() {
    if (!this.activeOption) {
      return;
    }
    return _selectOption(this.activeOption);
  }
  open() {
    open(this);
  }
  close() {
    close(this);
  }
  toggle() {
    toggle(this);
  }
  search(query) {
    return search(this, query);
  }
  cancelSearch() {
    cancelSearch(this);
  }
  focusInput() {
    focusInput(this);
  }
  blurInput() {
    blurInput(this);
  }
  setInputValue(value) {
    setInputValue(this, value);
  }
  activateOptionForValue(value, config) {
    activateOptionForValue(this, value, config);
  }
  activateOptionAtIndex(index, config) {
    activateOptionAtIndex(this, index, config);
  }
  activateNextOption(config) {
    activateNextOption(this, config);
  }
  activatePreviousOption(config) {
    activatePreviousOption(this, config);
  }
  activateOptionForKeyCode(keyCode, config) {
    activateOptionForKeyCode(this, keyCode, config);
  }
  deactivateOptions() {
    deactivateOptions(this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "activeOptionIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return -1;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isFulfilled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isPending", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isReady", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isRejected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isSearching", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isSettled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isSlowSearch", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "value", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "input", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "option", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "options", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "selectedOption", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "selectedOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleInsertElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsertElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDestroyElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDestroyElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUpdateValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdateValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInsertOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsertOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDestroyOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDestroyOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInsertOptions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsertOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDestroyOptions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDestroyOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInsertSelectedOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsertSelectedOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDestroySelectedOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDestroySelectedOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInsertSelectedOptions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsertSelectedOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDestroySelectedOptions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDestroySelectedOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInsertInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsertInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDestroyInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDestroyInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInputText", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInputText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFocusOut", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleFocusOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyPress", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyPress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSelectOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSelectOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleActivateOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleActivateOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "select", [action], Object.getOwnPropertyDescriptor(_class.prototype, "select"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectActiveOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectActiveOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "search", [action], Object.getOwnPropertyDescriptor(_class.prototype, "search"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelSearch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "blurInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "blurInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setInputValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setInputValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activateOptionForValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "activateOptionForValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activateOptionAtIndex", [action], Object.getOwnPropertyDescriptor(_class.prototype, "activateOptionAtIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activateNextOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "activateNextOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activatePreviousOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "activatePreviousOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activateOptionForKeyCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "activateOptionForKeyCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deactivateOptions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deactivateOptions"), _class.prototype), _class);
export { SelectBox as default };